// Default profile image path
export const DEFAULT_PROFILE_IMAGE = "/images/sadGato.jpg";

//JANITORS PAGE
// Sample data for Janitors
export const JANITORS_DATA = [
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Maria Santos",
      employeeId: "TUPM-21-3421",
      email: "maria.santos@tup.edu.ph",
      contact: "+639234567890",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Maria Santos",
      date: "2024-03-15",
      shift: "Morning",
      timeIn: "08:00 AM",
      timeOut: "05:00 PM",
      cleaningHour: "8 hours",
      task: "General Cleaning",
      status: "On Time"
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Maria Santos",
      today: 8,
      thisWeek: 40,
      thisMonth: 160,
      thisYear: 1920,
      status: "Excellent",
      employeeId: "JAN-001"
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Maria Santos",
      resource: "Cleaning Supplies",
      amountUsed: "5 units",
      remaining: "15 units",
      restocked: "Yes",
      note: "Normal Usage",
      employeeId: "JAN-001"
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Maria Santos",
      date: "2024-03-15",
      startTime: "08:00 AM",
      endTime: "05:00 PM",
      duration: 8,
      task: "General Cleaning",
      beforePicture: "/images/before.jpg",
      afterPicture: "/images/after.jpg",
      status: "Done"
    }
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Juan Dela Cruz",
      employeeId: "TUPM-21-8765",
      email: "juan.delacruz@tup.edu.ph",
      contact: "+639876543210",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Juan Dela Cruz",
      date: "2024-01-22",
      shift: "Afternoon Shift",
      timeIn: "03:00 PM",
      timeOut: "11:00 PM",
      cleaningHour: "02:30 PM",
      task: "Restock",
      status: "Late",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Juan Dela Cruz",
      today: 7,
      thisWeek: 38,
      thisMonth: 152,
      thisYear: 1824,
      maxCleaningHours: 8,
      minCleaningHours: 6,
      status: "Good",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Juan Dela Cruz",
      resource: "Disinfectant Spray",
      amountUsed: "1.2L",
      remaining: "3.8L",
      restocked: "Yes",
      note: "Higher than Average",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Juan Dela Cruz",
      date: "2024-01-22",
      startTime: "03:15 PM",
      endTime: "05:00 PM",
      duration: "1.75",
      task: "Restroom Sanitation",
      beforePicture: "/images/before2.jpg",
      afterPicture: "/images/after2.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Elena Rodriguez",
      employeeId: "TUPM-21-5432",
      email: "elena.rodriguez@tup.edu.ph",
      contact: "+639345678912",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Elena Rodriguez",
      date: "2024-01-22",
      shift: "Night Shift",
      timeIn: "11:00 PM",
      timeOut: "07:00 AM",
      cleaningHour: "10:30 PM",
      task: "Cleaning",
      status: "On Time",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Elena Rodriguez",
      today: 6,
      thisWeek: 35,
      thisMonth: 140,
      thisYear: 1680,
      maxCleaningHours: 8,
      minCleaningHours: 6,
      status: "Fair",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Elena Rodriguez",
      resource: "Paper Towels",
      amountUsed: "5 rolls",
      remaining: "15 rolls",
      restocked: "No",
      note: "Excessive Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Elena Rodriguez",
      date: "2024-01-22",
      startTime: "11:15 PM",
      endTime: "01:30 AM",
      duration: "2.25",
      task: "Deep Cleaning",
      beforePicture: "/images/before3.jpg",
      afterPicture: "/images/after3.jpg",
      status: "Pending",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Ricardo Lim",
      employeeId: "TUPM-21-9876",
      email: "ricardo.lim@tup.edu.ph",
      contact: "+639123456789",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Ricardo Lim",
      date: "2024-01-22",
      shift: "Morning Shift",
      timeIn: "07:00 AM",
      timeOut: "03:00 PM",
      cleaningHour: "06:45 AM",
      task: "Cleaning",
      status: "On Time",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Ricardo Lim",
      today: 8,
      thisWeek: 40,
      thisMonth: 160,
      thisYear: 1920,
      maxCleaningHours: 9,
      minCleaningHours: 7,
      status: "Excellent",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Ricardo Lim",
      resource: "Glass Cleaner",
      amountUsed: "1.8L",
      remaining: "4.2L",
      restocked: "No",
      note: "Normal Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Ricardo Lim",
      date: "2024-01-22",
      startTime: "07:30 AM",
      endTime: "09:00 AM",
      duration: "1.5",
      task: "Window Cleaning",
      beforePicture: "/images/before4.jpg",
      afterPicture: "/images/after4.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Isabella Reyes",
      employeeId: "TUPM-21-2468",
      email: "isabella.reyes@tup.edu.ph",
      contact: "+639987654321",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Isabella Reyes",
      date: "2024-01-22",
      shift: "Afternoon Shift",
      timeIn: "03:00 PM",
      timeOut: "11:00 PM",
      cleaningHour: "02:45 PM",
      task: "Cleaning",
      status: "On Time",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Isabella Reyes",
      today: 7,
      thisWeek: 37,
      thisMonth: 148,
      thisYear: 1776,
      maxCleaningHours: 8,
      minCleaningHours: 6,
      status: "Good",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Isabella Reyes",
      resource: "Floor Wax",
      amountUsed: "2L",
      remaining: "6L",
      restocked: "Yes",
      note: "Normal Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Isabella Reyes",
      date: "2024-01-22",
      startTime: "03:30 PM",
      endTime: "05:15 PM",
      duration: "1.75",
      task: "Floor Waxing",
      beforePicture: "/images/before5.jpg",
      afterPicture: "/images/after5.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Gabriel Torres",
      employeeId: "TUPM-21-1357",
      email: "gabriel.torres@tup.edu.ph",
      contact: "+639876543210",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Gabriel Torres",
      date: "2024-01-22",
      shift: "Night Shift",
      timeIn: "11:00 PM",
      timeOut: "07:00 AM",
      cleaningHour: "10:45 PM",
      task: "Cleaning",
      status: "On Time",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Gabriel Torres",
      today: 7,
      thisWeek: 39,
      thisMonth: 156,
      thisYear: 1872,
      maxCleaningHours: 8,
      minCleaningHours: 6,
      status: "Good",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Gabriel Torres",
      resource: "Disinfectant",
      amountUsed: "1.5L",
      remaining: "5.5L",
      restocked: "No",
      note: "Normal Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Gabriel Torres",
      date: "2024-01-22",
      startTime: "11:15 PM",
      endTime: "01:00 AM",
      duration: "1.75",
      task: "Sanitization",
      beforePicture: "/images/before6.jpg",
      afterPicture: "/images/after6.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Sofia Cruz",
      employeeId: "TUPM-21-7890",
      email: "sofia.cruz@tup.edu.ph",
      contact: "+639234567891",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Sofia Cruz",
      date: "2024-01-22",
      shift: "Morning Shift",
      timeIn: "07:00 AM",
      timeOut: "03:00 PM",
      cleaningHour: "06:45 AM",
      task: "Cleaning",
      status: "Late",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Sofia Cruz",
      today: 6,
      thisWeek: 36,
      thisMonth: 144,
      thisYear: 1728,
      maxCleaningHours: 8,
      minCleaningHours: 6,
      status: "Fair",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Sofia Cruz",
      resource: "Mop Heads",
      amountUsed: "3 units",
      remaining: "12 units",
      restocked: "Yes",
      note: "Normal Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Sofia Cruz",
      date: "2024-01-22",
      startTime: "07:30 AM",
      endTime: "09:15 AM",
      duration: "1.75",
      task: "Floor Mopping",
      beforePicture: "/images/before7.jpg",
      afterPicture: "/images/after7.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Lucas Garcia",
      employeeId: "TUPM-21-4567",
      email: "lucas.garcia@tup.edu.ph",
      contact: "+639345678912",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Lucas Garcia",
      date: "2024-01-22",
      shift: "Afternoon Shift",
      timeIn: "03:00 PM",
      timeOut: "11:00 PM",
      cleaningHour: "02:45 PM",
      task: "Restock",
      status: "On Time",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Lucas Garcia",
      today: 8,
      thisWeek: 41,
      thisMonth: 164,
      thisYear: 1968,
      maxCleaningHours: 9,
      minCleaningHours: 7,
      status: "Excellent",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Lucas Garcia",
      resource: "Cleaning Cloths",
      amountUsed: "10 pieces",
      remaining: "40 pieces",
      restocked: "No",
      note: "Normal Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Lucas Garcia",
      date: "2024-01-22",
      startTime: "03:15 PM",
      endTime: "05:00 PM",
      duration: "1.75",
      task: "Surface Cleaning",
      beforePicture: "/images/before8.jpg",
      afterPicture: "/images/after8.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Emma Santos",
      employeeId: "TUPM-21-6789",
      email: "emma.santos@tup.edu.ph",
      contact: "+639456789123",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Emma Santos",
      date: "2024-01-22",
      shift: "Night Shift",
      timeIn: "11:00 PM",
      timeOut: "07:00 AM",
      cleaningHour: "10:45 PM",
      task: "Cleaning",
      status: "On Time",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Emma Santos",
      today: 7,
      thisWeek: 38,
      thisMonth: 152,
      thisYear: 1824,
      maxCleaningHours: 8,
      minCleaningHours: 6,
      status: "Good",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Emma Santos",
      resource: "Trash Bags",
      amountUsed: "20 pieces",
      remaining: "80 pieces",
      restocked: "Yes",
      note: "Normal Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Emma Santos",
      date: "2024-01-22",
      startTime: "11:15 PM",
      endTime: "01:00 AM",
      duration: "1.75",
      task: "Waste Collection",
      beforePicture: "/images/before9.jpg",
      afterPicture: "/images/after9.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Diego Reyes",
      employeeId: "TUPM-21-3456",
      email: "diego.reyes@tup.edu.ph",
      contact: "+639567891234",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Diego Reyes",
      date: "2024-01-22",
      shift: "Morning Shift",
      timeIn: "07:00 AM",
      timeOut: "03:00 PM",
      cleaningHour: "06:45 AM",
      task: "Cleaning",
      status: "On Time",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Diego Reyes",
      today: 8,
      thisWeek: 40,
      thisMonth: 160,
      thisYear: 1920,
      maxCleaningHours: 9,
      minCleaningHours: 7,
      status: "Excellent",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Diego Reyes",
      resource: "Hand Sanitizer",
      amountUsed: "1L",
      remaining: "4L",
      restocked: "No",
      note: "Normal Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Diego Reyes",
      date: "2024-01-22",
      startTime: "07:15 AM",
      endTime: "09:00 AM",
      duration: "1.75",
      task: "Sanitization",
      beforePicture: "/images/before10.jpg",
      afterPicture: "/images/after10.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Olivia Torres",
      employeeId: "TUPM-21-2345",
      email: "olivia.torres@tup.edu.ph",
      contact: "+639678912345",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Olivia Torres",
      date: "2024-01-22",
      shift: "Afternoon Shift",
      timeIn: "03:00 PM",
      timeOut: "11:00 PM",
      cleaningHour: "02:45 PM",
      task: "Cleaning",
      status: "Late",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Olivia Torres",
      today: 6,
      thisWeek: 35,
      thisMonth: 140,
      thisYear: 1680,
      maxCleaningHours: 8,
      minCleaningHours: 6,
      status: "Fair",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Olivia Torres",
      resource: "Broom",
      amountUsed: "2 units",
      remaining: "8 units",
      restocked: "Yes",
      note: "Normal Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Olivia Torres",
      date: "2024-01-22",
      startTime: "03:30 PM",
      endTime: "05:15 PM",
      duration: "1.75",
      task: "Sweeping",
      beforePicture: "/images/before11.jpg",
      afterPicture: "/images/after11.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Mateo Cruz",
      employeeId: "TUPM-21-1234",
      email: "mateo.cruz@tup.edu.ph",
      contact: "+639789123456",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Mateo Cruz",
      date: "2024-01-22",
      shift: "Night Shift",
      timeIn: "11:00 PM",
      timeOut: "07:00 AM",
      cleaningHour: "10:45 PM",
      task: "Cleaning",
      status: "On Time",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Mateo Cruz",
      today: 7,
      thisWeek: 39,
      thisMonth: 156,
      thisYear: 1872,
      maxCleaningHours: 8,
      minCleaningHours: 6,
      status: "Good",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Mateo Cruz",
      resource: "Vacuum Bags",
      amountUsed: "2 pieces",
      remaining: "8 pieces",
      restocked: "No",
      note: "Normal Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Mateo Cruz",
      date: "2024-01-22",
      startTime: "11:15 PM",
      endTime: "01:00 AM",
      duration: "1.75",
      task: "Vacuuming",
      beforePicture: "/images/before12.jpg",
      afterPicture: "/images/after12.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Luna Garcia",
      employeeId: "TUPM-21-8901",
      email: "luna.garcia@tup.edu.ph",
      contact: "+639891234567",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Luna Garcia",
      date: "2024-01-22",
      shift: "Morning Shift",
      timeIn: "07:00 AM",
      timeOut: "03:00 PM",
      cleaningHour: "06:45 AM",
      task: "Restock",
      status: "On Time",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Luna Garcia",
      today: 8,
      thisWeek: 41,
      thisMonth: 164,
      thisYear: 1968,
      maxCleaningHours: 9,
      minCleaningHours: 7,
      status: "Excellent",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Luna Garcia",
      resource: "Air Freshener",
      amountUsed: "1.5L",
      remaining: "4.5L",
      restocked: "Yes",
      note: "Normal Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Luna Garcia",
      date: "2024-01-22",
      startTime: "07:15 AM",
      endTime: "09:00 AM",
      duration: "1.75",
      task: "Air Freshening",
      beforePicture: "/images/before13.jpg",
      afterPicture: "/images/after13.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Sebastian Santos",
      employeeId: "TUPM-21-7890",
      email: "sebastian.santos@tup.edu.ph",
      contact: "+639912345678",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Sebastian Santos",
      date: "2024-01-22",
      shift: "Afternoon Shift",
      timeIn: "03:00 PM",
      timeOut: "11:00 PM",
      cleaningHour: "02:45 PM",
      task: "Cleaning",
      status: "On Time",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Sebastian Santos",
      today: 7,
      thisWeek: 38,
      thisMonth: 152,
      thisYear: 1824,
      maxCleaningHours: 8,
      minCleaningHours: 6,
      status: "Good",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Sebastian Santos",
      resource: "Sponges",
      amountUsed: "5 pieces",
      remaining: "20 pieces",
      restocked: "No",
      note: "Normal Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Sebastian Santos",
      date: "2024-01-22",
      startTime: "03:15 PM",
      endTime: "05:00 PM",
      duration: "1.75",
      task: "Surface Cleaning",
      beforePicture: "/images/before14.jpg",
      afterPicture: "/images/after14.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Victoria Reyes",
      employeeId: "TUPM-21-6789",
      email: "victoria.reyes@tup.edu.ph",
      contact: "+639123456789",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Victoria Reyes",
      date: "2024-01-22",
      shift: "Night Shift",
      timeIn: "11:00 PM",
      timeOut: "07:00 AM",
      cleaningHour: "10:45 PM",
      task: "Cleaning",
      status: "On Time",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Victoria Reyes",
      today: 8,
      thisWeek: 40,
      thisMonth: 160,
      thisYear: 1920,
      maxCleaningHours: 9,
      minCleaningHours: 7,
      status: "Excellent",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Victoria Reyes",
      resource: "Gloves",
      amountUsed: "3 pairs",
      remaining: "12 pairs",
      restocked: "Yes",
      note: "Normal Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Victoria Reyes",
      date: "2024-01-22",
      startTime: "11:15 PM",
      endTime: "01:00 AM",
      duration: "1.75",
      task: "Deep Cleaning",
      beforePicture: "/images/before15.jpg",
      afterPicture: "/images/after15.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Adrian Torres",
      employeeId: "TUPM-21-5678",
      email: "adrian.torres@tup.edu.ph",
      contact: "+639234567890",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Adrian Torres",
      date: "2024-01-22",
      shift: "Morning Shift",
      timeIn: "07:00 AM",
      timeOut: "03:00 PM",
      cleaningHour: "06:45 AM",
      task: "Cleaning",
      status: "Late",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Adrian Torres",
      today: 6,
      thisWeek: 35,
      thisMonth: 140,
      thisYear: 1680,
      maxCleaningHours: 8,
      minCleaningHours: 6,
      status: "Fair",
    },
    resourceUsage: {
      image: "/images/sadGato.jpg",
      name: "Adrian Torres",
      resource: "Dust Masks",
      amountUsed: "4 pieces",
      remaining: "16 pieces",
      restocked: "No",
      note: "Normal Usage",
    },
    logsReport: {
      image: "/images/sadGato.jpg",
      name: "Adrian Torres",
      date: "2024-01-22",
      startTime: "07:30 AM",
      endTime: "09:15 AM",
      duration: "1.75",
      task: "Dusting",
      beforePicture: "/images/before16.jpg",
      afterPicture: "/images/after16.jpg",
      status: "Done",
    },
  },
  {
    basicDetails: {
      image: "/images/sadGato.jpg",
      name: "Camila Cruz",
      employeeId: "TUPM-21-4567",
      email: "camila.cruz@tup.edu.ph",
      contact: "+639345678901",
    },
    schedule: {
      image: "/images/sadGato.jpg",
      name: "Camila Cruz",
      date: "2024-01-22",
      shift: "Afternoon Shift",
      timeIn: "03:00 PM",
      timeOut: "11:00 PM",
      cleaningHour: "02:45 PM",
      task: "Restock",
      status: "On Time",
    },
    performanceTrack: {
      image: "/images/sadGato.jpg",
      name: "Camila Cruz",
      today: 7,
      thisWeek: 37,
      thisMonth: 148,
      thisYear: 1776,
      maxCleaningHours: 8,
      minCleaningHours: 6,
      status: "Good",
    },
  },
];

//USERS PAGE
// Sample data for Users
export const USERS_DATA = [
  {
    name: "Isabella Cruz",
    employeeId: "TUPM-22-0001",
    email: "isabella.cruz@tup.edu.ph",
    contact: "+639111222333",
    position: "Janitor",
    priority: true,
    status: "Pending",
  },
  {
    name: "Rafael Mendoza",
    employeeId: "TUPM-22-0002",
    email: "rafael.mendoza@tup.edu.ph",
    contact: "+639222333444",
    position: "Maintenance",
    priority: false,
    status: "Declined",
  },
  {
    name: "Carmen Ramos",
    employeeId: "TUPM-22-0003",
    email: "carmen.ramos@tup.edu.ph",
    contact: "+639333444555",
    position: "Janitor",
    priority: true,
    status: "Accepted",
  },
  {
    name: "Antonio Santos",
    employeeId: "TUPM-22-0004",
    email: "antonio.santos@tup.edu.ph",
    contact: "+639444555666",
    position: "Security",
    priority: false,
    status: "Pending",
  },
  {
    name: "Beatriz Luna",
    employeeId: "TUPM-22-0005",
    email: "beatriz.luna@tup.edu.ph",
    contact: "+639555666777",
    position: "Janitor",
    priority: true,
    status: "Pending",
  },
  {
    name: "Gabriel Reyes",
    employeeId: "TUPM-22-0006",
    email: "gabriel.reyes@tup.edu.ph",
    contact: "+639666777888",
    position: "Maintenance",
    priority: false,
    status: "Pending",
  },
  {
    name: "Maria Gonzales",
    employeeId: "TUPM-21-0007",
    email: "maria.gonzales@tup.edu.ph",
    contact: "+639777888999",
    position: "Security",
    priority: false,
    status: "Accepted",
  },
  {
    name: "Juan dela Cruz",
    employeeId: "TUPM-21-0001",
    email: "juan.delacruz@tup.edu.ph",
    contact: "+639111222333",
    position: "Janitor",
    priority: true,
    status: "Accepted",
  },
  {
    name: "Isabella Cruz",
    employeeId: "TUPM-21-0008",
    email: "isabella.cruz@tup.edu.ph",
    contact: "+639888999000",
    position: "Security",
    priority: false,
    status: "Accepted",
  },
  {
    name: "Roberto Santos",
    employeeId: "TUPM-22-0008",
    email: "roberto.santos@tup.edu.ph",
    contact: "+639888999000",
    position: "Maintenance",
    priority: true,
    status: "Accepted",
  },
  {
    name: "Teresa Luna",
    employeeId: "TUPM-22-0009",
    email: "teresa.luna@tup.edu.ph",
    contact: "+639999000111",
    position: "Janitor",
    priority: false,
    status: "Accepted",
  },
  {
    name: "Carlos Reyes",
    employeeId: "TUPM-22-0010",
    email: "carlos.reyes@tup.edu.ph",
    contact: "+639000111222",
    position: "Security",
    priority: true,
    status: "Accepted",
  },
  {
    name: "Beatriz Garcia",
    employeeId: "TUPM-22-0011",
    email: "beatriz.garcia@tup.edu.ph",
    contact: "+639111222333",
    position: "Maintenance",
    priority: false,
    status: "Pending",
  },
  {
    name: "Manuel Torres",
    employeeId: "TUPM-22-0012",
    email: "manuel.torres@tup.edu.ph",
    contact: "+639222333444",
    position: "Janitor",
    priority: true,
    status: "Accepted",
  },
  {
    name: "Lucia Mendoza",
    employeeId: "TUPM-22-0013",
    email: "lucia.mendoza@tup.edu.ph",
    contact: "+639333444555",
    position: "Security",
    priority: false,
    status: "Pending",
  },
  {
    name: "Felipe Cruz",
    employeeId: "TUPM-22-0014",
    email: "felipe.cruz@tup.edu.ph",
    contact: "+639444555666",
    position: "Maintenance",
    priority: true,
    status: "Pending",
  },
  {
    name: "Rosa Santos",
    image: "./images/sadGato.jpg",
    employeeId: "TUPM-22-0015",
    email: "rosa.santos@tup.edu.ph",
    contact: "+639555666777",
    position: "Janitor",
    priority: false,
    status: "Declined",
  },
];

//PROFILE PAGE
// Sample data for Profile
export const PROFILE_DATA = [
  {
    name: "Nathan Drake",
    email: "nathan.drake@tup.edu.ph",
    employeeId: "TUPM-21-0001",
    position: "Manager",
  },
];

//RESOURCES PAGE
//Sample data for Inventory Table - Resources Page
export const RESOURCES_DATA = [
  {
    resources: "PPE",
    currentStock: 100,
    restockThreshold: 50,
    recommendedRestockingTime: "2024-01-15",
    recommendedRestock: 100,
    lastRestocked: "2023-12-15",
    nextRestockingDate: "2024-01-15",
    status: "Sufficient",
  },
  {
    resources: "Bleach",
    currentStock: 75,
    restockThreshold: 30,
    recommendedRestockingTime: "2024-01-20",
    recommendedRestock: 50,
    lastRestocked: "2023-12-20",
    nextRestockingDate: "2024-01-20",
    status: "Sufficient",
  },
  {
    resources: "Mops",
    currentStock: 45,
    restockThreshold: 20,
    recommendedRestockingTime: "2024-01-25",
    recommendedRestock: 40,
    lastRestocked: "2023-12-25",
    nextRestockingDate: "2024-01-25",
    status: "Sufficient",
  },
  {
    resources: "Brooms",
    currentStock: 35,
    restockThreshold: 15,
    recommendedRestockingTime: "2024-01-30",
    recommendedRestock: 30,
    lastRestocked: "2023-12-30",
    nextRestockingDate: "2024-01-30",
    status: "Sufficient",
  },
  {
    resources: "Gloves",
    currentStock: 25,
    restockThreshold: 40,
    recommendedRestockingTime: "2024-01-10",
    recommendedRestock: 80,
    lastRestocked: "2023-12-10",
    nextRestockingDate: "2024-01-10",
    status: "Almost Out",
  },
  {
    resources: "Trash Bags",
    currentStock: 150,
    restockThreshold: 100,
    recommendedRestockingTime: "2024-02-01",
    recommendedRestock: 200,
    lastRestocked: "2023-12-01",
    nextRestockingDate: "2024-02-01",
    status: "Sufficient",
  },
  {
    resources: "Disinfectant",
    currentStock: 15,
    restockThreshold: 25,
    recommendedRestockingTime: "2024-01-05",
    recommendedRestock: 50,
    lastRestocked: "2023-12-05",
    nextRestockingDate: "2024-01-05",
    status: "Almost Out",
  },
  {
    resources: "Paper Towels",
    currentStock: 0,
    restockThreshold: 30,
    recommendedRestockingTime: "2024-01-08",
    recommendedRestock: 60,
    lastRestocked: "2023-12-08",
    nextRestockingDate: "2024-01-08",
    status: "Empty",
  },
  {
    resources: "Hand Soap",
    currentStock: 40,
    restockThreshold: 20,
    recommendedRestockingTime: "2024-01-22",
    recommendedRestock: 40,
    lastRestocked: "2023-12-22",
    nextRestockingDate: "2024-01-22",
    status: "Sufficient",
  },
  {
    resources: "Toilet Paper",
    currentStock: 5,
    restockThreshold: 20,
    recommendedRestockingTime: "2024-01-12",
    recommendedRestock: 40,
    lastRestocked: "2023-12-12",
    nextRestockingDate: "2024-01-12",
    status: "Almost Out",
  },
  {
    resources: "Glass Cleaner",
    currentStock: 0,
    restockThreshold: 15,
    recommendedRestockingTime: "2024-01-18",
    recommendedRestock: 30,
    lastRestocked: "2023-12-18",
    nextRestockingDate: "2024-01-18",
    status: "Empty",
  },
  {
    resources: "Floor Wax",
    currentStock: 28,
    restockThreshold: 15,
    recommendedRestockingTime: "2024-02-05",
    recommendedRestock: 25,
    lastRestocked: "2023-12-05",
    nextRestockingDate: "2024-02-05",
    status: "Sufficient",
  },
  {
    resources: "Dust Masks",
    currentStock: 10,
    restockThreshold: 25,
    recommendedRestockingTime: "2024-01-14",
    recommendedRestock: 50,
    lastRestocked: "2023-12-14",
    nextRestockingDate: "2024-01-14",
    status: "Almost Out",
  },
  {
    resources: "Buckets",
    currentStock: 12,
    restockThreshold: 10,
    recommendedRestockingTime: "2024-01-28",
    recommendedRestock: 15,
    lastRestocked: "2023-12-28",
    nextRestockingDate: "2024-01-28",
    status: "Sufficient",
  },
  {
    resources: "Sponges",
    currentStock: 0,
    restockThreshold: 30,
    recommendedRestockingTime: "2024-01-16",
    recommendedRestock: 60,
    lastRestocked: "2023-12-16",
    nextRestockingDate: "2024-01-16",
    status: "Empty",
  },
  {
    resources: "Scrub Brushes",
    currentStock: 8,
    restockThreshold: 15,
    recommendedRestockingTime: "2024-01-19",
    recommendedRestock: 25,
    lastRestocked: "2023-12-19",
    nextRestockingDate: "2024-01-19",
    status: "Almost Out",
  },
  {
    resources: "Air Freshener",
    currentStock: 45,
    restockThreshold: 20,
    recommendedRestockingTime: "2024-02-10",
    recommendedRestock: 40,
    lastRestocked: "2023-12-10",
    nextRestockingDate: "2024-02-10",
    status: "Sufficient",
  },
  {
    resources: "Sanitizer",
    currentStock: 5,
    restockThreshold: 25,
    recommendedRestockingTime: "2024-01-13",
    recommendedRestock: 50,
    lastRestocked: "2023-12-13",
    nextRestockingDate: "2024-01-13",
    status: "Almost Out",
  },
  {
    resources: "Vacuum Bags",
    currentStock: 0,
    restockThreshold: 10,
    recommendedRestockingTime: "2024-01-21",
    recommendedRestock: 20,
    lastRestocked: "2023-12-21",
    nextRestockingDate: "2024-01-21",
    status: "Empty",
  },
  {
    resources: "Dusters",
    currentStock: 30,
    restockThreshold: 15,
    recommendedRestockingTime: "2024-02-15",
    recommendedRestock: 25,
    lastRestocked: "2023-12-15",
    nextRestockingDate: "2024-02-15",
    status: "Sufficient",
  },
];

// Sample data for Reminders
export const REMINDERS_DATA = [
  {
    date: "Today",
    items: [
      {
        name: "Maria Santos",
        resource: "Bleach",
        status: "Excessive Usage",
      },
      {
        name: "John Cruz",
        resource: "Water Usage",
        status: "Higher than Average",
      },
      {
        name: "Anna Reyes",
        resource: "Sanitizer",
        status: "Almost Empty",
      },
    ],
  },
  {
    date: "01/15/24",
    items: [
      {
        name: "Pedro Garcia",
        resource: "Detergent",
        status: "Higher than Average",
      },
      {
        name: "Sofia Lopez",
        resource: "PPE",
        status: "Low Stock",
      },
      {
        name: "Marco Tan",
        resource: "Mops",
        status: "Needs Replacement",
      },
      {
        name: "Luis Torres",
        resource: "Air Freshener",
        status: "Almost Empty",
      },
    ],
  },
  {
    date: "01/18/24",
    items: [
      {
        name: "Diana Lee",
        resource: "Vacuum Bags",
        status: "Empty",
      },
    ],
  },
  {
    date: "01/22/24",
    items: [
      {
        name: "Carlos Santos",
        resource: "Water Usage",
        status: "Excessive Usage",
      },
      {
        name: "Maya Cruz",
        resource: "Bleach",
        status: "Higher than Average",
      },
      {
        name: "Gabriel Lim",
        resource: "Dusters",
        status: "Low Stock",
      },
      {
        name: "Emma Garcia",
        resource: "Sanitizer",
        status: "Almost Empty",
      },
      {
        name: "Lucas Reyes",
        resource: "PPE",
        status: "Needs Replacement",
      },
    ],
  },
  {
    date: "01/25/24",
    items: [
      {
        name: "Isabella Santos",
        resource: "Detergent",
        status: "Excessive Usage",
      },
      {
        name: "Miguel Lopez",
        resource: "Mops",
        status: "Needs Replacement",
      },
    ],
  },
];

// USAGE MONITOR PAGE
// Sample data for Janitor Schedule
export const JANITOR_SCHEDULE_DATA = [
  {
    janitor: "Maria Santos",
    lastCleaning: "8:00 AM",
    scheduled: "8:00 AM",
    status: "Done",
  },
  {
    janitor: "John Smith",
    lastCleaning: "9:15 AM",
    scheduled: "9:00 AM",
    status: "Done",
  },
  {
    janitor: "Alice Johnson",
    lastCleaning: "10:30 AM",
    scheduled: "10:00 AM",
    status: "Overdue",
  },
  {
    janitor: "Bob Wilson",
    lastCleaning: "11:45 AM",
    scheduled: "11:30 AM",
    status: "Done",
  },
  {
    janitor: "Carol Brown",
    lastCleaning: "1:00 PM",
    scheduled: "1:00 PM",
    status: "Done",
  },
];

// Sample data for Usage Card Report
export const USAGE_CARD_REPORT_DATA = [
  {
    title: "Today",
    count: 110,
    isLive: true,
  },
  {
    title: "Today",
    count: 95,
    isLive: false,
  },
  {
    title: "Yesterday",
    count: 850,
    isLive: false,
  },
  {
    title: "This Week",
    count: 3240,
    isLive: false,
  },
  {
    title: "This Month",
    count: 2890,
    isLive: false,
  },
  {
    title: "This Year",
    count: 3100,
    isLive: false,
  },
];

// Sample data for Inventory Table - Usage Monitor
export const USAGE_MONITOR_DATA = [
  {
    timeStamp: "2025-01-16 08:00 AM",
    capacity: { value: "85%", status: "High Capacity", color: "text-red-500" },
    waterLevel: { value: "25%", status: "Low", color: "text-orange-500" },
    odor: { value: "Moderate", color: "text-yellow-500" },
    temperature: { value: "75°F", status: "Normal", color: "text-green-500" },
    actionRequired: "Restock water resources soon",
  },
  {
    timeStamp: "2025-01-16 09:30 AM",
    capacity: { value: "70%", status: "Moderate", color: "text-yellow-500" },
    waterLevel: { value: "40%", status: "Medium", color: "text-yellow-500" },
    odor: { value: "Low", color: "text-green-500" },
    temperature: { value: "72°F", status: "Normal", color: "text-green-500" },
    actionRequired: "Monitor water levels",
  },
  {
    timeStamp: "2025-01-16 11:00 AM",
    capacity: { value: "55%", status: "Normal", color: "text-green-500" },
    waterLevel: { value: "60%", status: "Adequate", color: "text-green-500" },
    odor: { value: "Low", color: "text-green-500" },
    temperature: { value: "74°F", status: "Normal", color: "text-green-500" },
    actionRequired: "No action needed",
  },
  {
    timeStamp: "2025-01-16 12:30 PM",
    capacity: { value: "40%", status: "Low", color: "text-red-500" },
    waterLevel: { value: "80%", status: "High", color: "text-red-500" },
    odor: { value: "Moderate", color: "text-yellow-500" },
    temperature: { value: "76°F", status: "Normal", color: "text-green-500" },
    actionRequired: "Restock water resources soon",
  },
  {
    timeStamp: "2025-01-16 1:45 PM",
    capacity: { value: "30%", status: "Low", color: "text-red-500" },
    waterLevel: { value: "90%", status: "High", color: "text-red-500" },
    odor: { value: "Low", color: "text-green-500" },
    temperature: { value: "78°F", status: "Normal", color: "text-green-500" },
    actionRequired: "Monitor water levels",
  },
];
